/**
 * Reparto de la barra de usos de un boleto.
 *
 * Un hueco por consumo. El techo existe porque hay centros con bonos de
 * decenas de miles de usos (el centro 3208 los tiene de 100.000): pintar un
 * recuadro por uso ahí bloquearía el diálogo, así que por encima del techo la
 * barra pasa a ser continua y proporcional.
 *
 * Se separa del componente para poder fijar el reparto con tests: el bono de
 * 12 sesiones de la incidencia 869f3yj40 dibujaba sólo 10 huecos, y al llegar
 * al décimo consumo saltaba a un segundo bloque de 10 huecos de los que 8 no
 * existían.
 */
export const MAX_SEGMENTED_SLOTS = 50;

export type ConsumptionSlot = 'consumed' | 'available';

export type ConsumptionBar =
    | { mode: 'segmented'; slots: ConsumptionSlot[] }
    | { mode: 'continuous'; consumedRatio: number };

/**
 * La API devuelve el consumo unas veces en positivo y otras en negativo, y no
 * siempre entero, así que normalizamos antes de repartir.
 */
function toCount(value: number): number {
    return Number.isFinite(value) ? Math.floor(Math.abs(value)) : 0;
}

export function buildConsumptionBar(
    amount: number,
    consumed: number,
): ConsumptionBar {
    const total = toCount(amount);
    const used = Math.min(toCount(consumed), total);

    if (total === 0) {
        return { mode: 'segmented', slots: [] };
    }

    if (total > MAX_SEGMENTED_SLOTS) {
        return { mode: 'continuous', consumedRatio: used / total };
    }

    return {
        mode: 'segmented',
        slots: Array.from({ length: total }, (_, index) =>
            index < used ? 'consumed' : 'available',
        ),
    };
}
